import { render, staticRenderFns } from "./PositionDetail.vue?vue&type=template&id=b560c618&"
import script from "./PositionDetail.vue?vue&type=script&lang=js&"
export * from "./PositionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports